import * as stylex from "@stylexjs/stylex";
import Image from "next/image";
import Link from "next/link";
import { graphql, unmaskFragment } from "@/gql";
import imageLoader from "@/imageLoader";
/**
 * The underlying DOM element which is rendered by this component.
 */ const Root = Link;
export function Brick(props) {
    const { blob: blob0, ...rest } = props;
    const blob = unmaskFragment(BrickFragment, blob0);
    return <Root href={`/b/${blob.name}`} prefetch={false} className="x1lliihq xeuugli" {...rest}>
      {(()=>{
        if (blob.asImage) {
            const image = unmaskFragment(ImageFragment, blob.asImage);
            return <Image className="x1lliihq xh8yej3 xt7dq6l x1r1mewj" alt="" sizes="(min-width: 1376px) 25vw, (min-width: 1060px) 30vw, (min-width: 744px) 50vw, 100vw" src={image.url} loader={imageLoader} {...image.dimensions}/>;
        }
        if (blob.asVideo) {
            const image = unmaskFragment(ImageFragment, blob.asVideo.poster);
            return <Image className="x1lliihq xh8yej3 xt7dq6l x1r1mewj" alt="" sizes="(min-width: 1376px) 25vw, (min-width: 1060px) 30vw, (min-width: 744px) 50vw, 100vw" src={image.url} loader={imageLoader} {...image.dimensions}/>;
        }
        return null;
    })()}
    </Root>;
}
const ImageFragment = graphql(/* GraphQL */ `
  fragment ImageFragment on Image {
    id

    url
    dimensions {
      width
      height
    }
  }
`);
const BrickFragment = graphql(/* GraphQL */ `
  fragment BrickFragment on Blob {
    id

    name

    asImage {
      id
      ...ImageFragment
    }

    asVideo {
      id

      poster {
        id
        ...ImageFragment
      }
    }
  }
`);
